import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import AppIcon from 'components/icons/AppIcon';

const STEPS = [
  { number: 1, classSuffix: 'One' },
  { number: 2, classSuffix: 'Two' },
  { number: 3, classSuffix: 'Three' },
];

const HowItWorks = (
  <div className="my-5 text-center checkoutCardTitle">
    <LocalizedMessage id="info.howWork" />
  </div>
);

// eslint-disable-next-line react/prop-types
const Step = ({ number, classSuffix }) => (
  <React.Fragment>
    <div className="d-flex justify-content-center align-items-center">
      <span className={`mr-3 tutorialCircleBox tutorialBackgroundColor${classSuffix}`}>{number}</span>
      <span className={`tutorialTitle tutorialColor${classSuffix}`}>
        <LocalizedMessage id={
        /* eslint-disable */
         classSuffix === 'One'   ? 'info.checkout.tutorialTitleOne' :
         classSuffix === 'Two'   ? 'info.checkout.tutorialTitleTwo' :
         classSuffix === 'Three' ? 'info.checkout.tutorialTitleThree' : ''
        /* eslint-enable */
        }
        />
      </span>
    </div>
    <div className={`d-flex justify-content-center align-items-center checkoutTutorialBox tutorialBackgroundColor${classSuffix}`}>
      <AppIcon id="btnOpenDoor" fontSize="large" className="mr-3" />
      <LocalizedMessage id={
        /* eslint-disable */
         classSuffix === 'One'   ? 'info.checkout.tutorialOne' :
         classSuffix === 'Two'   ? 'info.checkout.tutorialTwo' :
         classSuffix === 'Three' ? 'info.checkout.tutorialThree' : ''
        /* eslint-enable */
        }
      />
    </div>
  </React.Fragment>
);

const CheckoutTutorial = () => (
  <React.Fragment>
    {HowItWorks}
    <div className="d-flex flex-column" style={{ gap: 30 }}>
      {STEPS.map(Step)}
    </div>
  </React.Fragment>
);

export default CheckoutTutorial;



// WEBPACK FOOTER //
// ./routes/checkout/components/CheckoutTutorial.js